import React, {useEffect, useState} from 'react';
import {Button} from "antd";

function QrResetButton({handlePVQrReset, pvId}) {
    const [showButton, setShowButton] = useState(false)

    useEffect(() => {
        const handleKeyDown = (event) => {
            // Check if the key combination matches Command + K
            if (event.metaKey && event.key === 'k') {
                setShowButton(true);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    useEffect(() => {
        const handleKeyDown = (event) => {
            // Check if the key combination matches Command + K
            if (event.metaKey && event.key === 'x') {
                setShowButton(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (
        <div style={{display: showButton ? 'block' : 'none'}}>
            <Button style={{marginLeft: '5px'}} type="default" size='small'
                    onClick={() => handlePVQrReset(pvId)}>QR Reset</Button>
        </div>
    );
}

export default QrResetButton;
